import type { PropsWithChildren } from "react";
import { IoCloseOutline } from "react-icons/io5";
import {
  Sheet as S,
  type SheetHeaderProps,
  type SheetProps,
  type SheetContentProps,
} from "react-modal-sheet";

import { cn } from "shared/utils/cn";

import { Button } from "./button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
} & SheetProps;

export const Sheet = (props: Props) => {
  const { isOpen, onClose, className, children, ...restProps } = props;
  return (
    <S
      {...restProps}
      className={className}
      unstyled
      isOpen={isOpen}
      onClose={onClose}
    >
      <S.Container className="bg-oil border-dark-grey overflow-hidden rounded-t-[40px] border">
        {children}
      </S.Container>
    </S>
  );
};

type HeaderProps = {
  className?: string;
  onClose?: () => void;
} & SheetHeaderProps;

const Header = (props: PropsWithChildren<HeaderProps>) => {
  const { onClose, className, children, ...restProps } = props;
  return (
    <S.Header
      unstyled
      className={cn(
        "flex items-center gap-x-3 px-4 pt-3.5 text-lg leading-5.5 tracking-[0.4px] text-white",
        className
      )}
      {...restProps}
    >
      {onClose && (
        <Button theme="white" size="34" rounded onClick={onClose}>
          <IoCloseOutline className="size-6 text-black" />
        </Button>
      )}

      {children}
    </S.Header>
  );
};

type ContentProps = {
  className?: string;
} & SheetContentProps;

const Content = ({ className, ...props }: PropsWithChildren<ContentProps>) => {
  return <S.Content className={cn("mt-7.5 px-4", className)} {...props} />;
};

Sheet.Header = Header;
Sheet.Content = Content;
